import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { CONTACT_EMAIL } from "@/hooks/useLeadSubmit";

const NEXT_STEPS = [
  "We read your request and check the sites, apps or documents you listed.",
  "Within 24 hours (working days) we email you with questions or a proposed scope.",
  "You get an engagement letter with the scope, timeline and fixed fee before any work starts.",
];

/**
 * Shown after a landing-page lead is stored. noindex: it should only ever be
 * reached by submitting the form, never from search. Keyboard and screen-reader
 * focus lands on the <h1> after the client-side navigation from the form
 * (RouteFocus moves focus to the main content's heading on route change).
 */
const WcagAuditThankYou = () => (
  <div className="min-h-screen bg-background">
    <Seo title="Thank you — request received" path="/wcag-audit/thank-you" noindex />
    <Navbar />
    <main id="main-content" tabIndex={-1} className="section-padding pt-36 md:pt-44">
      <div className="mx-auto max-w-3xl">
        <p className="eyebrow mb-4">Request received</p>
        <h1 className="mb-4 font-display text-4xl font-bold text-foreground md:text-5xl">
          Thank you — we have your request
        </h1>
        <p className="mb-8 max-w-xl text-lg leading-relaxed text-muted-foreground">
          Your request has reached our audit team. Here is what happens next.
        </p>
        <ol className="mb-10 list-none space-y-4">
          {NEXT_STEPS.map((step, i) => (
            <li key={step} className="flex gap-4 text-base text-foreground">
              <span className="font-mono text-sm font-bold text-primary" aria-hidden="true">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span>{step}</span>
            </li>
          ))}
        </ol>
        <p className="mb-8 text-base text-muted-foreground">
          Need to add something? Email{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="font-medium text-primary underline underline-offset-4 rounded-sm focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus-ring"
          >
            {CONTACT_EMAIL}
          </a>
          .
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button variant="hero" size="lg" className="min-h-[44px]" asChild>
            <Link to="/blog">Read our accessibility guides</Link>
          </Button>
          <Button variant="hero-outline" size="lg" className="min-h-[44px]" asChild>
            <Link to="/">Go to the home page</Link>
          </Button>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default WcagAuditThankYou;
